import { InputHTMLAttributes } from 'react';
import './InputSlider.scss';

interface IInputSliderProps extends InputHTMLAttributes<HTMLInputElement> {}

const InputSlider = (props: IInputSliderProps) => {
  return (
    <input
      type='range'
      {...props}
      className={`input-slider ${props.className ?? ''}`}
      style={{
        background: `linear-gradient(to right, var(--primary) ${props.value}%, var(--app-background) ${props.value}%)`,
      }}
    />
  );
};

export default InputSlider;
